import React, {useEffect, useRef, useState} from "react";
import {useOverrides, Override} from "@quarkly/components";
import {Text, Span, Box, Button, Icon, Section} from "@quarkly/widgets";
import {IoIosCheckmark} from "react-icons/io";
import {Input, Modal, Select, Space, Tooltip} from "antd";
import {CreditCardOutlined, InfoCircleOutlined, LoadingOutlined} from "@ant-design/icons";
import {useSearchParams} from "../hook/useSearchParams";
import {priceMonthly} from "../priceData";
import {useReferralCode} from "./ReferralHandler";

const defaultProps = {
    "padding": "80px 0",
    "background": "transparent",
    "color": "#ffffff"
};

const overrides = {};

const CdzvPricingUA = props => {
    const {getReferralCode} = useReferralCode();
    const {override, children, rest} = useOverrides(props, overrides, defaultProps);
    let [userLang, setUserLang] = useState('ua');

    // States for declarative checkout modal
    const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [tvName, setTvName] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [checkoutError, setCheckoutError] = useState('');

    const searchParams = useSearchParams();
    const pay = searchParams.get('pay');
    const pay_id = searchParams.get('pid');
    const utm_medium = searchParams.get('utm_medium');
    const utm_source = searchParams.get('utm_source');
    const utm_campaign = searchParams.get('utm_campaign');
    const utm_content = searchParams.get('utm_content');

    useEffect(() => {
        if (pay === 'sxiniosax') {
            const element = document.getElementById('aichat');
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }, [pay]);

    function getCurrentPrice(index) {
        return priceMonthly[index];
    }

    function redirectToMainPage() {
        window.location.href = 'https://panel.cdzv.com/';
    }

    async function postTelegramData(data = {}) {
        const url = 'https://kslukgrih5xid2ijqazpczomae0qkbbi.lambda-url.eu-central-1.on.aws/';
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            redirect: "follow",
            body: JSON.stringify(data)
        });
        return await response.json();
    }

    async function postApiData(data = {}) {
        const url = 'https://api.cdzv.com/';
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            redirect: "follow",
            body: JSON.stringify(data)
        });
        return await response.json();
    }

    function handleCheckoutSubmit() {
        const trimmedEmail = email.trim();
        const trimmedTvName = tvName.trim() || 'none';

        if (!trimmedEmail || trimmedEmail.length < 5 || !trimmedEmail.includes('@') || !trimmedEmail.includes('.')) {
            setCheckoutError('Будь ласка, введіть коректну адресу e-mail.');
            return;
        }

        setCheckoutError('');
        setIsSubmitting(true);

        const refCode = getReferralCode() || '';
        const paymentType = 1; // Webhook Server subscription index

        if (window.js_track) {
            window.js_track(trimmedEmail);
        }

        postTelegramData({
            action: 'new_user',
            email: trimmedEmail,
            tv_user: trimmedTvName,
            type: getCurrentPrice(paymentType).package_id,
            package: getCurrentPrice(paymentType).name,
            lang: userLang,
            ref_code: refCode
        }).then(() => {}).finally(() => {
            postApiData({
                action: 'new_user',
                email: trimmedEmail,
                tv_user: trimmedTvName,
                type: getCurrentPrice(paymentType).package_id,
                package: getCurrentPrice(paymentType).name,
                lang: userLang,
                ref_code: refCode
            }).then(() => {}).finally(() => {
                window.location.href = getCurrentPrice(paymentType).url + 
                    '?email=' + trimmedEmail + 
                    '&prefilled_email=' + trimmedEmail + 
                    '&utm_medium=' + trimmedEmail.replace('@', '_').replace('.', '-') + 
                    '&utm_source=' + trimmedTvName.replace('@', '_').replace('.', '-') + 
                    '&utm_campaign=' + getCurrentPrice(paymentType).package_id + 
                    '&utm_content=' + userLang;
            });
        });
    }

    const showConfirmPayment = () => {
        Modal.info({
            title: 'Вітаємо з успішною підпискою!',
            width: 650,
            content: (
                <div style={{ padding: '10px 0', fontSize: '15px', lineHeight: '1.6' }}>
                    <strong>E-Mail:</strong> {utm_medium ? utm_medium.replace('_', '@').replace('-', '.') : ''}<br/>
                    <strong>TradingView:</strong> {utm_source ? utm_source.replace('_', '@').replace('-', '.') : ''}<br/><br/>
                    Ви успішно оформили підписку.<br/><br/>
                    Ми створюємо Ваш особистий кабінет та активуємо преміум-модуль <strong>SMART Grid PRO</strong>. Зазвичай це займає до 1 хвилини.<br/><br/>
                    Лист із інструкціями щодо доступу та активації індикаторів у TradingView відправлено на вашу пошту.
                </div>
            ),
            footer: () => (
                <div style={{ textAlign: 'center', fontWeight: '600', color: '#8a2be2', padding: '10px' }}>
                    Перенаправлення в кабінет за кілька секунд...
                </div>
            )
        });

        try {
            postTelegramData({
                action: 'payment',
                email: utm_medium.replace('_', '@').replace('-', '.'),
                tv_user: utm_source.replace('_', '@').replace('-', '.'),
                package: utm_campaign,
            });
        } catch (e) {
            console.log(e);
        }

        try {
            postApiData({
                action: 'payment',
                email: utm_medium.replace('_', '@').replace('-', '.'),
                tv_user: utm_source.replace('_', '@').replace('-', '.'),
                package: utm_campaign,
                payid: pay_id,
                lang: utm_content
            });
        } catch (e) {
            console.log(e);
        }

        setTimeout(() => {
            redirectToMainPage();
        }, 15000);
    };

    return (
        <Section {...rest} style={{ background: 'transparent', padding: '100px 20px' }}>
            {pay && showConfirmPayment()}
            
            <style dangerouslySetInnerHTML={{__html: `
                .pricing-container {
                    max-width: 1100px;
                    margin: 0 auto;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 40px;
                    padding-top: 40px;
                }
                .pricing-card {
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 24px;
                    padding: 48px;
                    display: flex;
                    flex-direction: column;
                    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.37);
                    backdrop-filter: blur(12px);
                    -webkit-backdrop-filter: blur(12px);
                }
                .pricing-card:hover {
                    transform: translateY(-6px);
                    border-color: rgba(255, 255, 255, 0.15);
                    box-shadow: 0 20px 50px rgba(123, 47, 206, 0.2);
                    background: rgba(255, 255, 255, 0.05);
                }
                .pricing-card.premium {
                    background: linear-gradient(180deg, rgba(138, 43, 226, 0.08) 0%, rgba(10, 3, 20, 0.6) 100%);
                    border-color: rgba(138, 43, 226, 0.25);
                    box-shadow: 0 15px 45px rgba(138, 43, 226, 0.1);
                }
                .pricing-card.premium:hover {
                    border-color: rgba(138, 43, 226, 0.6);
                    box-shadow: 0 25px 60px rgba(138, 43, 226, 0.25);
                    background: linear-gradient(180deg, rgba(138, 43, 226, 0.12) 0%, rgba(10, 3, 20, 0.7) 100%);
                }
                .pricing-card.premium::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, rgba(138, 43, 226, 0.12) 0%, transparent 60%);
                    pointer-events: none;
                }
                .badge {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    background: rgba(255, 255, 255, 0.08);
                    border: 1px solid rgba(255, 255, 255, 0.15);
                    padding: 6px 14px;
                    border-radius: 30px;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 1px;
                    text-transform: uppercase;
                    color: rgba(255, 255, 255, 0.85);
                }
                .badge.popular {
                    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%) !important;
                    border: none !important;
                    box-shadow: 0 4px 12px rgba(138, 43, 226, 0.3) !important;
                    color: #ffffff !important;
                }
                .plan-title {
                    font-size: 28px;
                    font-weight: 800;
                    margin-bottom: 8px;
                    letter-spacing: -0.5px;
                    color: #ffffff;
                }
                .plan-desc {
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.65);
                    line-height: 1.6;
                    margin-bottom: 30px;
                    min-height: 48px;
                }
                .plan-price-box {
                    margin-bottom: 35px;
                    display: flex;
                    align-items: baseline;
                }
                .plan-price {
                    font-size: 58px;
                    font-weight: 800;
                    letter-spacing: -2px;
                    line-height: 1;
                    background: linear-gradient(135deg, #ffffff 0%, #d8bfd8 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .plan-period {
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-left: 10px;
                    font-weight: 500;
                }
                .features-list {
                    list-style: none;
                    padding: 0;
                    margin: 0 0 40px 0;
                    flex-grow: 1;
                }
                .feature-item {
                    display: flex;
                    align-items: flex-start;
                    font-size: 15px;
                    color: rgba(255, 255, 255, 0.85);
                    margin-bottom: 16px;
                    line-height: 1.5;
                }
                .feature-icon {
                    color: #10b981;
                    font-size: 22px;
                    margin-right: 12px;
                    flex-shrink: 0;
                    margin-top: 1px;
                }
                .feature-icon.highlight {
                    color: #FD6DF9;
                }
                .pricing-card.premium .feature-icon {
                    color: #8a2be2;
                }
                .btn-action {
                    display: block;
                    width: 100%;
                    padding: 18px;
                    border-radius: 14px;
                    font-size: 16px;
                    font-weight: 700;
                    text-align: center;
                    text-decoration: none;
                    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
                    border: none;
                    cursor: pointer;
                    margin-bottom: 14px;
                    outline: none;
                }
                .btn-action:last-child {
                    margin-bottom: 0;
                }
                .btn-action.free-dl {
                    background: rgba(255, 255, 255, 0.05);
                    color: #ffffff;
                    border: 1px solid rgba(255, 255, 255, 0.12);
                }
                .btn-action.free-dl:hover {
                    background: rgba(255, 255, 255, 0.12);
                    border-color: rgba(255, 255, 255, 0.25);
                    transform: translateY(-2px);
                }
                .btn-action.subscribe {
                    background: linear-gradient(135deg, #8a2be2 0%, #4b0082 100%) !important;
                    color: #ffffff !important;
                    box-shadow: 0 6px 20px rgba(138, 43, 226, 0.25) !important;
                }
                .btn-action.subscribe:hover {
                    box-shadow: 0 10px 30px rgba(138, 43, 226, 0.45) !important;
                    transform: translateY(-2px) !important;
                    background: linear-gradient(135deg, #a855f7 0%, #6b21a8 100%) !important;
                }
                
                /* Premium checkout modal custom classes */
                .premium-checkout-modal .ant-modal-content {
                    background: #0d0714 !important;
                    border: 1px solid rgba(255, 255, 255, 0.08) !important;
                    border-radius: 20px !important;
                    box-shadow: 0 20px 50px rgba(123, 47, 206, 0.3) !important;
                    color: #ffffff !important;
                    padding: 24px 32px !important;
                }
                .premium-checkout-modal .ant-modal-header {
                    background: transparent !important;
                    border-bottom: none !important;
                    margin-bottom: 12px !important;
                }
                .premium-checkout-modal .ant-modal-title {
                    color: #ffffff !important;
                    font-size: 22px !important;
                    font-weight: 800 !important;
                    font-family: 'Plus Jakarta Sans', sans-serif !important;
                }
                .premium-checkout-modal .ant-modal-close {
                    color: rgba(255, 255, 255, 0.5) !important;
                }
                .premium-checkout-modal .ant-modal-close:hover {
                    color: #ffffff !important;
                }
                .premium-input {
                    background: rgba(255, 255, 255, 0.03) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    border-radius: 10px !important;
                    color: #ffffff !important;
                    height: 44px !important;
                    font-family: inherit !important;
                    transition: all 0.3s ease !important;
                }
                .premium-input::placeholder {
                    color: rgba(255, 255, 255, 0.4) !important;
                }
                .premium-input:focus, .premium-input:hover {
                    border-color: #8a2be2 !important;
                    box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.15) !important;
                    background: rgba(255, 255, 255, 0.05) !important;
                }
                .premium-select .ant-select-selector {
                    background: rgba(255, 255, 255, 0.03) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    border-radius: 10px !important;
                    color: #ffffff !important;
                    height: 44px !important;
                    transition: all 0.3s ease !important;
                }
                .premium-select:hover .ant-select-selector, .premium-select-focused .ant-select-selector {
                    border-color: #8a2be2 !important;
                }
                .premium-select .ant-select-selection-item {
                    color: #ffffff !important;
                    line-height: 42px !important;
                    font-weight: 500 !important;
                }
                .premium-select .ant-select-arrow {
                    color: rgba(255, 255, 255, 0.6) !important;
                }
                .spinner-spin {
                    display: inline-block;
                    width: 16px;
                    height: 16px;
                    border: 2px solid rgba(255,255,255,0.3);
                    border-radius: 50%;
                    border-top-color: #ffffff;
                    animation: spinCustom 1s linear infinite;
                    margin-right: 8px;
                }
                @keyframes spinCustom {
                    to { transform: rotate(360deg); }
                }
                
                @media (max-width: 768px) {
                    .pricing-container {
                        grid-template-columns: 1fr;
                        gap: 30px;
                    }
                    .pricing-card {
                        padding: 32px;
                    }
                    .pricing-title {
                        font-size: 32px !important;
                        margin-bottom: 12px !important;
                    }
                    .pricing-desc {
                        font-size: 16px !important;
                    }
                }
            `}} />

            <div style={{ textAlign: 'center', marginBottom: '70px' }}>
                <h2 className="pricing-title" style={{ fontSize: '46px', fontWeight: '800', marginBottom: '16px', color: '#ffffff', letterSpacing: '-1.5px', lineHeight: '1.2', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                    Прості та чесні умови
                </h2>
                <p className="pricing-desc" style={{ fontSize: '19px', color: 'rgba(255, 255, 255, 0.65)', maxWidth: '650px', margin: '0 auto', lineHeight: '1.6', fontWeight: '400' }}>
                    Використовуйте інструменти безкоштовно. Сплачуйте за Webhook-сервер лише тоді, коли вам дійсно потрібна автоматизація торгівлі.
                </p>
            </div>

            <div className="pricing-container">
                {/* Free Tools Card */}
                <div className="pricing-card">
                    <span className="badge">100% Безкоштовно</span>
                    <h3 className="plan-title">CDZV Безкоштовний набір</h3>
                    <p className="plan-desc">
                        Збирайте власні торгові стратегії у візуальному редакторі та легко ребалансуйте портфель.
                    </p>
                    <div className="plan-price-box">
                        <span className="plan-price">$0</span>
                        <span className="plan-period">назавжди</span>
                    </div>
                    <ul className="features-list">
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span><strong>CDZV Toolkit</strong> — візуально збирайте умови входу та виходу прямо на графіку TradingView</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span><strong>Coin Rebalancer</strong> — модуль, що кожні 15 хвилин перевіряє ваги монет на біржі та підрівнює ваш портфель</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Наші авторські індикатори CDZV для точного пошуку трендових зон</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Перевірка ваших ідей на історії котирувань за 3 кліки без ризику реальними грошима</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>5 готових шаблонів стратегій, які можна відразу запустити в роботу</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Спілкування та допомога з налаштуваннями у нашому Telegram-чаті</span>
                        </li>
                    </ul>
                    <div>
                        <a 
                            href="https://t.me/c/cdzv_com/35178" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="btn-action free-dl"
                        >
                            Скачати CDZV Toolkit (Telegram)
                        </a>
                        <a 
                            href="https://t.me/cdzv_com/13302/35129" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="btn-action free-dl"
                            style={{ background: 'rgba(16, 185, 129, 0.05)', borderColor: 'rgba(16, 185, 129, 0.2)', color: '#10b981' }}
                            onMouseOver={(e) => {
                                e.currentTarget.style.background = 'rgba(16, 185, 129, 0.1)';
                                e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.3)';
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.background = 'rgba(16, 185, 129, 0.05)';
                                e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.2)';
                            }}
                        >
                            Скачати Coin Rebalancer (Telegram)
                        </a>
                    </div>
                </div>

                {/* Webhook Server Subscription Card */}
                <div className="pricing-card premium">
                    <span className="badge popular">Вигідний комплект</span>
                    <h3 className="plan-title">Webhook Server + SMART Grid PRO</h3>
                    <p className="plan-desc">
                        Повне автовиконання ваших сигналів на біржах 24/7 та ексклюзивний доступ до сіткових ордерів.
                    </p>
                    <div className="plan-price-box">
                        <span className="plan-price">$40</span>
                        <span className="plan-period">в місяць</span>
                    </div>
                    <ul className="features-list">
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span><strong>SMART Grid PRO (Включено!)</strong> — доступ до сіткового алгоритму, який автоматично усереднює ціну при просадках</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Особистий кабінет користувача, де SMART Grid PRO активується автоматично після оплати</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Миттєве виконання сигналів з графіків TradingView на вашому акаунті Binance, Bybit чи OKX</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Ваші стратегії торгують цілодобово. Комп'ютер чи телефон тримати увімкненими не потрібно</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Автоматичне підключення до Bybit, Binance, OKX через безпечні API-ключі</span>
                        </li>
                        <li className="feature-item">
                            <IoIosCheckmark className="feature-icon" />
                            <span>Прямий зв'язок з розробником у Telegram при будь-яких труднощах з налаштуванням</span>
                        </li>
                    </ul>
                    <button 
                        onClick={() => setIsCheckoutOpen(true)}
                        className="btn-action subscribe"
                    >
                        Оформити підписку через Stripe
                    </button>
                </div>
            </div>

            {/* Premium checkout declarative modal */}
            <Modal
                title="Реєстрація кабінету та перехід до оплати"
                open={isCheckoutOpen}
                onCancel={() => !isSubmitting && setIsCheckoutOpen(false)}
                footer={null}
                width={560}
                className="premium-checkout-modal"
                destroyOnClose={true}
            >
                <Space direction="vertical" size="middle" style={{ width: '100%', marginTop: '10px' }}>
                    <p style={{ fontSize: '14px', color: 'rgba(255, 255, 255, 0.7)', lineHeight: '1.5' }}>
                        Введіть свої дані. Ми створимо для вас особистий кабінет, де після оплати буде активовано доступ до <strong>SMART Grid PRO</strong>.
                    </p>
                    
                    <div>
                        <Input
                            placeholder="Ваш e-mail"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                if (checkoutError) setCheckoutError('');
                            }}
                            disabled={isSubmitting}
                            className="premium-input"
                            autoFocus={true}
                        />
                        {checkoutError && (
                            <div style={{ color: '#ff4d4f', fontSize: '12px', marginTop: '4px', fontWeight: '500' }}>
                                {checkoutError}
                            </div>
                        )}
                    </div>

                    <Input
                        placeholder="Ваш нікнейм у TradingView"
                        value={tvName}
                        onChange={(e) => setTvName(e.target.value)}
                        disabled={isSubmitting}
                        className="premium-input"
                    />

                    <Select
                        defaultValue="ua"
                        value={userLang}
                        placeholder="Виберіть мову"
                        onChange={(value) => setUserLang(value)}
                        disabled={isSubmitting}
                        className="premium-select"
                        style={{ width: '100%', height: '44px' }}
                        options={[
                            { value: 'en', label: 'English' },
                            { value: 'ua', label: 'Українська' },
                            { value: 'ru', label: 'Русский' }
                        ]}
                    />

                    <p style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.5)', lineHeight: '1.5', marginTop: '8px' }}>
                        <InfoCircleOutlined style={{ color: '#8a2be2', marginRight: '4px' }}/> Якщо у Вас немає нікнейму у TradingView, напишіть '<strong>none</strong>'.<br/>
                        <InfoCircleOutlined style={{ color: '#8a2be2', marginRight: '4px' }}/> Пишіть нам на <strong><a href="mailto:support@cdzv.com" style={{ color: '#8a2be2', textDecoration: 'none' }}>support@cdzv.com</a></strong> за будь-яких труднощів.
                    </p>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '20px' }}>
                        <button
                            onClick={() => setIsCheckoutOpen(false)}
                            disabled={isSubmitting}
                            style={{
                                background: 'transparent',
                                border: '1px solid rgba(255, 255, 255, 0.15)',
                                color: 'rgba(255, 255, 255, 0.8)',
                                padding: '10px 22px',
                                borderRadius: '10px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.25s ease'
                            }}
                            onMouseOver={(e) => { if (!isSubmitting) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'; }}
                            onMouseOut={(e) => { e.currentTarget.style.background = 'transparent'; }}
                        >
                            Скасувати
                        </button>
                        <button
                            onClick={handleCheckoutSubmit}
                            disabled={isSubmitting}
                            style={{
                                background: 'linear-gradient(135deg, #8a2be2 0%, #4b0082 100%)',
                                color: '#ffffff',
                                border: 'none',
                                padding: '10px 24px',
                                borderRadius: '10px',
                                fontWeight: '700',
                                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                boxShadow: '0 4px 12px rgba(138, 43, 226, 0.25)',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                opacity: isSubmitting ? 0.8 : 1
                            }}
                            onMouseOver={(e) => { if (!isSubmitting) e.currentTarget.style.boxShadow = '0 6px 18px rgba(138, 43, 226, 0.4)'; }}
                            onMouseOut={(e) => { e.currentTarget.style.boxShadow = '0 4px 12px rgba(138, 43, 226, 0.25)'; }}
                        >
                            {isSubmitting ? (
                                <>
                                    <span className="spinner-spin" />
                                    Обробка...
                                </>
                            ) : (
                                <>
                                    <CreditCardOutlined style={{ marginRight: '8px' }} />
                                    Оплатити карткою через Stripe
                                </>
                            )}
                        </button>
                    </div>
                </Space>
            </Modal>
            
            {children}
        </Section>
    );
};

Object.assign(CdzvPricingUA, {
    ...Section,
    defaultProps,
    overrides
});

export default CdzvPricingUA;